export const setupTerms = () => {
  const close = document.getElementById("terms-close");
  close?.addEventListener("click", closeTerms);

  const open = document.querySelectorAll("[data-open-terms]");
  open.forEach((o) => o.addEventListener("click", showTerms));
};

const closeTerms = () => {
  const thanks = document.getElementById("terms");

  thanks?.classList.remove("terms--visible");
};

export const showTerms = () => {
  const thanks = document.getElementById("terms");

  thanks?.classList.add("terms--visible");
};
